import styled, { css } from "styled-components";
import { IControl } from ".";
import {
  iPadLandscapeOnly,
  iPadPortraitOnly
} from "../../../../../../ui/_utils/styleUtils";
import { StyledCombinedSpinButton, StyledKeypadButton } from "../Buttons";
import { SpinButtonWrapper } from "../Wrappers";

export const Wrapper = styled.div`
  display: flex;
  padding: 0.8em 0;
  justify-content: space-between;

  @media (orientation: landscape) {
    flex-direction: column;
    justify-content: flex-end;
    flex: 1 0 auto;
    align-self: ${({ isLeftHandMode }: IControl) =>
      isLeftHandMode ? "flex-start" : "flex-end"};
    ${({ isLeftHandMode }: IControl) =>
      isLeftHandMode ? "margin-left: 1em" : "margin-right: 1em"};

    ${SpinButtonWrapper} {
      ${({ isMinimalUI, autoplayRunning }: IControl) =>
        isMinimalUI && !autoplayRunning && `flex: 0 1 0`};
    }

    ${StyledCombinedSpinButton} {
      ${({ isLeftHandMode }: IControl) => isLeftHandMode && `left: 30%`};
    }

    ${StyledKeypadButton} {
      ${({ isMinimalUI, autoplayRunning }: IControl) =>
        isMinimalUI && !autoplayRunning && `flex-grow: 1`};
    }
  }

  @media (orientation: portrait) {
    padding: 0.6em;
    flex-direction: row-reverse;

    ${SpinButtonWrapper} {
      ${({ useFullscreen, isMinimalUI, autoplayRunning }: IControl) =>
        useFullscreen && (!isMinimalUI || autoplayRunning) && `flex: 1 0 20%`};
    }

    ${StyledCombinedSpinButton} {
      ${({ useFullscreen, isMinimalUI, autoplayRunning }: IControl) =>
        useFullscreen && (!isMinimalUI || autoplayRunning) && `bottom: 50%`};
    }

    ${StyledKeypadButton} {
      ${({ useFullscreen, isMinimalUI, autoplayRunning }: IControl) =>
        useFullscreen && (!isMinimalUI || autoplayRunning) && `flex-grow: 1`};
    }
  }

  ${iPadPortraitOnly(css`
    margin: 0 auto;
  `)}

  ${iPadLandscapeOnly(css`
    flex: 0;
    margin: auto 1em;
  `)}
`;
